import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-org-settings-audio-files',
  templateUrl: './org-settings-audio-files.component.html',
  styleUrls: ['./org-settings-audio-files.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgSettingsAudioFilesComponent {}
